module.exports = __webpack_public_path__ + "media/components/utils/fonts/BellMTStd-Regular-70f9fc80aebc405abc45fab49b74b054.otf";